/* tslint:disable */
/* eslint-disable */
/**
 * ForecastForReceiptManage API
 * 受領用内示の情報を操作するやつ
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 客先内示関連情報
 * @export
 * @interface BaseBusinessData
 */
export interface BaseBusinessData {
    /**
     * 売上先CD
     * @type {string}
     * @memberof BaseBusinessData
     */
    'customerNumber': string;
    /**
     * 売上先名
     * @type {string}
     * @memberof BaseBusinessData
     */
    'customerName': string;
    /**
     * 仕入先CD
     * @type {string}
     * @memberof BaseBusinessData
     */
    'supplierNumber': string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof BaseBusinessData
     */
    'supplierName': string;
    /**
     * 容量
     * @type {number}
     * @memberof BaseBusinessData
     */
    'package': number;
    /**
     * 商品CD
     * @type {string}
     * @memberof BaseBusinessData
     */
    'businessNumber': string;
    /**
     * 置場CD
     * @type {string}
     * @memberof BaseBusinessData
     */
    'warehouseNumber': string;
    /**
     * 置場名
     * @type {string}
     * @memberof BaseBusinessData
     */
    'warehouse': string;
    /**
     * 送り先CD
     * @type {string}
     * @memberof BaseBusinessData
     */
    'salesDestinationNumber': string;
    /**
     * 送り先名
     * @type {string}
     * @memberof BaseBusinessData
     */
    'salesDestinationName': string;
    /**
     * 商品名
     * @type {string}
     * @memberof BaseBusinessData
     */
    'businessName': string;
    /**
     * 受領用内示メモ
     * @type {string}
     * @memberof BaseBusinessData
     */
    'forecastForReceiptMemo': string;
}
/**
 * 受領用内示を一括更新する情報
 * @export
 * @interface BulkUpdateForecastForReceiptInfo
 */
export interface BulkUpdateForecastForReceiptInfo {
    /**
     * 更新対象の受領用内示IDリスト
     * @type {Array<string>}
     * @memberof BulkUpdateForecastForReceiptInfo
     */
    'forecastForReceiptIds': Array<string>;
    /**
     * 担当者IDリスト
     * @type {Array<string>}
     * @memberof BulkUpdateForecastForReceiptInfo
     */
    'forecastForReceiptResponsibleUserIdList': Array<string>;
    /**
     * 受領用内示名（名称変更時に使用）
     * @type {string}
     * @memberof BulkUpdateForecastForReceiptInfo
     */
    'forecastForReceiptName'?: string;
}
/**
 * 
 * @export
 * @interface BulkUpdateForecastForReceiptRequest
 */
export interface BulkUpdateForecastForReceiptRequest {
    /**
     * 
     * @type {BulkUpdateForecastForReceiptInfo}
     * @memberof BulkUpdateForecastForReceiptRequest
     */
    'bulkUpdateForecastForReceiptInfo'?: BulkUpdateForecastForReceiptInfo;
}
/**
 * 受領用内示一括更新レスポンスで返す情報
 * @export
 * @interface BulkUpdateForecastForReceiptResponse
 */
export interface BulkUpdateForecastForReceiptResponse {
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateForecastForReceiptResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateForecastForReceiptResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateForecastForReceiptResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof BulkUpdateForecastForReceiptResponse
     */
    'result': object;
}
/**
 * 受領用内示と関連取引情報の紐付けを解除するための情報 (中間テーブルから削除する)
 * @export
 * @interface DeleteBaseBusinessForecastForReceiptInfo
 */
export interface DeleteBaseBusinessForecastForReceiptInfo {
    /**
     * 受領用内示ID
     * @type {string}
     * @memberof DeleteBaseBusinessForecastForReceiptInfo
     */
    'forecastForReceiptId': string;
    /**
     * 関連取引ID
     * @type {Array<string>}
     * @memberof DeleteBaseBusinessForecastForReceiptInfo
     */
    'baseBusinessIds': Array<string>;
}
/**
 * 
 * @export
 * @interface DeleteBaseBusinessForecastForReceiptRequest
 */
export interface DeleteBaseBusinessForecastForReceiptRequest {
    /**
     * 
     * @type {DeleteBaseBusinessForecastForReceiptInfo}
     * @memberof DeleteBaseBusinessForecastForReceiptRequest
     */
    'deleteBaseBusinessForecastForReceiptInfo'?: DeleteBaseBusinessForecastForReceiptInfo;
}
/**
 * 受領用内示と関連取引情報の紐付けを解除するためのレスポンス
 * @export
 * @interface DeleteBaseBusinessToForecastForReceiptResponse
 */
export interface DeleteBaseBusinessToForecastForReceiptResponse {
    /**
     * 
     * @type {number}
     * @memberof DeleteBaseBusinessToForecastForReceiptResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof DeleteBaseBusinessToForecastForReceiptResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof DeleteBaseBusinessToForecastForReceiptResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof DeleteBaseBusinessToForecastForReceiptResponse
     */
    'result': object;
}
/**
 * 受領用内示を削除する情報
 * @export
 * @interface DeleteForecastForReceiptInfo
 */
export interface DeleteForecastForReceiptInfo {
    /**
     * 受領用内示ID
     * @type {string}
     * @memberof DeleteForecastForReceiptInfo
     */
    'forecastForReceiptId': string;
}
/**
 * 
 * @export
 * @interface DeleteForecastForReceiptRequest
 */
export interface DeleteForecastForReceiptRequest {
    /**
     * 
     * @type {DeleteForecastForReceiptInfo}
     * @memberof DeleteForecastForReceiptRequest
     */
    'deleteForecastForReceiptInfo'?: DeleteForecastForReceiptInfo;
}
/**
 * 受領用内示削除レスポンスで返す情報
 * @export
 * @interface DeleteForecastForReceiptResponse
 */
export interface DeleteForecastForReceiptResponse {
    /**
     * 
     * @type {number}
     * @memberof DeleteForecastForReceiptResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof DeleteForecastForReceiptResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof DeleteForecastForReceiptResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof DeleteForecastForReceiptResponse
     */
    'result': object;
}
/**
 * エラーレスポンス
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'headers': string;
    /**
     * 
     * @type {ErrorResponseBody}
     * @memberof ErrorResponse
     */
    'body': ErrorResponseBody;
}
/**
 * 
 * @export
 * @interface ErrorResponseBody
 */
export interface ErrorResponseBody {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponseBody
     */
    'statusCode': number;
    /**
     * 
     * @type {ErrorResponseCode}
     * @memberof ErrorResponseBody
     */
    'code': ErrorResponseCode;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseBody
     */
    'message': string;
}


/**
 * エラー時のレスポンスコード backendのcommon_layer/return_code.py参照
 * @export
 * @enum {string}
 */

export const ErrorResponseCode = {
    BadRequest: 'BAD_REQUEST',
    NotRegisteredBusiness: 'NOT_REGISTERED_BUSINESS',
    FkConstraintFailed: 'FK_CONSTRAINT_FAILED',
    Unauthorized: 'UNAUTHORIZED',
    Forbidden: 'FORBIDDEN',
    NotFound: 'NOT_FOUND',
    ResourceConflict: 'RESOURCE_CONFLICT',
    UpdateTimingConflict: 'UPDATE_TIMING_CONFLICT',
    InternalServerError: 'INTERNAL_SERVER_ERROR'
} as const;

export type ErrorResponseCode = typeof ErrorResponseCode[keyof typeof ErrorResponseCode];


/**
 * 受領用内示取得レスポンスで返す情報
 * @export
 * @interface GetForecastForReceiptResponse
 */
export interface GetForecastForReceiptResponse {
    /**
     * 
     * @type {number}
     * @memberof GetForecastForReceiptResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetForecastForReceiptResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetForecastForReceiptResponse
     */
    'message': string;
    /**
     * 
     * @type {GetForecastForReceiptResponseResult}
     * @memberof GetForecastForReceiptResponse
     */
    'result': GetForecastForReceiptResponseResult;
}
/**
 * 受領用内示取得レスポンスで返す情報
 * @export
 * @interface GetForecastForReceiptResponseResult
 */
export interface GetForecastForReceiptResponseResult {
    /**
     * 
     * @type {Array<GetForecastForReceiptResponseResultData>}
     * @memberof GetForecastForReceiptResponseResult
     */
    'data': Array<GetForecastForReceiptResponseResultData>;
}
/**
 * 受領用内示取得の個々の情報
 * @export
 * @interface GetForecastForReceiptResponseResultData
 */
export interface GetForecastForReceiptResponseResultData {
    /**
     * 受領用内示ID
     * @type {string}
     * @memberof GetForecastForReceiptResponseResultData
     */
    'forecastForReceiptId': string;
    /**
     * 受領用内示名
     * @type {string}
     * @memberof GetForecastForReceiptResponseResultData
     */
    'forecastForReceiptName': string;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof GetForecastForReceiptResponseResultData
     */
    'forecastForReceiptResponsibleUsers'?: Array<UserData>;
    /**
     * 出力範囲
     * @type {number}
     * @memberof GetForecastForReceiptResponseResultData
     */
    'outputRange': number;
}
/**
 * 担当者ごとの内示回収状況の個々の情報
 * @export
 * @interface GetForecastForReceiptStaffSummaryData
 */
export interface GetForecastForReceiptStaffSummaryData {
    /**
     * ユーザーID
     * @type {string}
     * @memberof GetForecastForReceiptStaffSummaryData
     */
    'userId': string;
    /**
     * ユーザー名
     * @type {string}
     * @memberof GetForecastForReceiptStaffSummaryData
     */
    'userName': string;
    /**
     * 回収済み内示数
     * @type {number}
     * @memberof GetForecastForReceiptStaffSummaryData
     */
    'recoveredForecastCount': number;
    /**
     * 合計内示数
     * @type {number}
     * @memberof GetForecastForReceiptStaffSummaryData
     */
    'totalForecastCount': number;
    /**
     * 最終更新日時（UNIXタイムスタンプ）
     * @type {number}
     * @memberof GetForecastForReceiptStaffSummaryData
     */
    'latestUpdateAt'?: number | null;
}
/**
 * 担当者ごとの内示回収状況レスポンス
 * @export
 * @interface GetForecastForReceiptStaffSummaryResponse
 */
export interface GetForecastForReceiptStaffSummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof GetForecastForReceiptStaffSummaryResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetForecastForReceiptStaffSummaryResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetForecastForReceiptStaffSummaryResponse
     */
    'message': string;
    /**
     * 
     * @type {GetForecastForReceiptStaffSummaryResponseResult}
     * @memberof GetForecastForReceiptStaffSummaryResponse
     */
    'result': GetForecastForReceiptStaffSummaryResponseResult;
}
/**
 * 担当者ごとの内示回収状況レスポンスで返す情報
 * @export
 * @interface GetForecastForReceiptStaffSummaryResponseResult
 */
export interface GetForecastForReceiptStaffSummaryResponseResult {
    /**
     * 
     * @type {Array<GetForecastForReceiptStaffSummaryData>}
     * @memberof GetForecastForReceiptStaffSummaryResponseResult
     */
    'data': Array<GetForecastForReceiptStaffSummaryData>;
}
/**
 * 受領用内示ごとの回収状況の個々の情報
 * @export
 * @interface GetForecastForReceiptSummaryData
 */
export interface GetForecastForReceiptSummaryData {
    /**
     * 受領用内示ID
     * @type {string}
     * @memberof GetForecastForReceiptSummaryData
     */
    'forecastForReceiptId': string;
    /**
     * 受領用内示名
     * @type {string}
     * @memberof GetForecastForReceiptSummaryData
     */
    'forecastForReceiptName': string;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof GetForecastForReceiptSummaryData
     */
    'userList': Array<UserData>;
    /**
     * キーワード
     * @type {string}
     * @memberof GetForecastForReceiptSummaryData
     */
    'keyword': string;
    /**
     * 回収済み内示数
     * @type {number}
     * @memberof GetForecastForReceiptSummaryData
     */
    'recoveredForecastCount': number;
    /**
     * 合計内示数
     * @type {number}
     * @memberof GetForecastForReceiptSummaryData
     */
    'totalForecastCount': number;
    /**
     * 最終更新日時（UNIXタイムスタンプ）
     * @type {number}
     * @memberof GetForecastForReceiptSummaryData
     */
    'latestUpdateAt'?: number | null;
}
/**
 * 受領用内示ごとの回収状況レスポンス
 * @export
 * @interface GetForecastForReceiptSummaryResponse
 */
export interface GetForecastForReceiptSummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof GetForecastForReceiptSummaryResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetForecastForReceiptSummaryResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetForecastForReceiptSummaryResponse
     */
    'message': string;
    /**
     * 
     * @type {GetForecastForReceiptSummaryResponseResult}
     * @memberof GetForecastForReceiptSummaryResponse
     */
    'result': GetForecastForReceiptSummaryResponseResult;
}
/**
 * 受領用内示ごとの回収状況レスポンスで返す情報
 * @export
 * @interface GetForecastForReceiptSummaryResponseResult
 */
export interface GetForecastForReceiptSummaryResponseResult {
    /**
     * 
     * @type {Array<GetForecastForReceiptSummaryData>}
     * @memberof GetForecastForReceiptSummaryResponseResult
     */
    'data': Array<GetForecastForReceiptSummaryData>;
}
/**
 * 受領用内示出力レスポンスで返す情報
 * @export
 * @interface GetOutputForecastForReceiptResponse
 */
export interface GetOutputForecastForReceiptResponse {
    /**
     * 
     * @type {number}
     * @memberof GetOutputForecastForReceiptResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetOutputForecastForReceiptResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetOutputForecastForReceiptResponse
     */
    'message': string;
    /**
     * 
     * @type {GetOutputForecastForReceiptResponseResult}
     * @memberof GetOutputForecastForReceiptResponse
     */
    'result': GetOutputForecastForReceiptResponseResult;
}
/**
 * 受領用内示出力レスポンスで返すリザルト
 * @export
 * @interface GetOutputForecastForReceiptResponseResult
 */
export interface GetOutputForecastForReceiptResponseResult {
    /**
     * 
     * @type {GetOutputForecastForReceiptResponseResultData}
     * @memberof GetOutputForecastForReceiptResponseResult
     */
    'data': GetOutputForecastForReceiptResponseResultData;
}
/**
 * 受領用内示出力レスポンスで返す情報
 * @export
 * @interface GetOutputForecastForReceiptResponseResultData
 */
export interface GetOutputForecastForReceiptResponseResultData {
    /**
     * 出力用Excelの本体(base64エンコードされた文字列)
     * @type {string}
     * @memberof GetOutputForecastForReceiptResponseResultData
     */
    'excelFile': string;
    /**
     * 受領用内示に関連する取引情報(keyが受領用内示名、valueが関連する取引情報)
     * @type {{ [key: string]: OutputForecastBusinessData; }}
     * @memberof GetOutputForecastForReceiptResponseResultData
     */
    'baseBusinesses': { [key: string]: OutputForecastBusinessData; };
}
/**
 * 受領用内示に関連する取引情報とその他の情報
 * @export
 * @interface OutputForecastBusinessData
 */
export interface OutputForecastBusinessData {
    /**
     * 受領用内示に関連する取引情報
     * @type {Array<BaseBusinessData>}
     * @memberof OutputForecastBusinessData
     */
    'baseBusinessList': Array<BaseBusinessData>;
    /**
     * 客先内示エクセルの出力期間範囲
     * @type {number}
     * @memberof OutputForecastBusinessData
     */
    'outputRange': number;
}
/**
 * 受領用内示と関連取引情報の紐付けを行うための情報 (中間テーブルに追加する)
 * @export
 * @interface PostBaseBusinessToForecastForReceiptInfo
 */
export interface PostBaseBusinessToForecastForReceiptInfo {
    /**
     * 受領用内示ID
     * @type {string}
     * @memberof PostBaseBusinessToForecastForReceiptInfo
     */
    'forecastForReceiptId': string;
    /**
     * 関連取引ID
     * @type {Array<string>}
     * @memberof PostBaseBusinessToForecastForReceiptInfo
     */
    'baseBusinessIds': Array<string>;
}
/**
 * 
 * @export
 * @interface PostBaseBusinessToForecastForReceiptRequest
 */
export interface PostBaseBusinessToForecastForReceiptRequest {
    /**
     * 
     * @type {PostBaseBusinessToForecastForReceiptInfo}
     * @memberof PostBaseBusinessToForecastForReceiptRequest
     */
    'postBaseBusinessToForecastForReceiptInfo'?: PostBaseBusinessToForecastForReceiptInfo;
}
/**
 * 受領用内示と関連取引情報の紐付けを行うためのレスポンス
 * @export
 * @interface PostBaseBusinessToForecastForReceiptResponse
 */
export interface PostBaseBusinessToForecastForReceiptResponse {
    /**
     * 
     * @type {number}
     * @memberof PostBaseBusinessToForecastForReceiptResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof PostBaseBusinessToForecastForReceiptResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof PostBaseBusinessToForecastForReceiptResponse
     */
    'message': string;
    /**
     * 
     * @type {PostBaseBusinessToForecastForReceiptResponseResult}
     * @memberof PostBaseBusinessToForecastForReceiptResponse
     */
    'result': PostBaseBusinessToForecastForReceiptResponseResult;
}
/**
 * 受領用内示と関連取引情報の紐付けを行なった際のレスポンス
 * @export
 * @interface PostBaseBusinessToForecastForReceiptResponseResult
 */
export interface PostBaseBusinessToForecastForReceiptResponseResult {
    /**
     * 受領用内示ID
     * @type {string}
     * @memberof PostBaseBusinessToForecastForReceiptResponseResult
     */
    'forecastForReceiptId': string;
}
/**
 * 受領用内示を作成する情報
 * @export
 * @interface PostForecastForReceiptInfo
 */
export interface PostForecastForReceiptInfo {
    /**
     * 受領用内示名
     * @type {string}
     * @memberof PostForecastForReceiptInfo
     */
    'forecastForReceiptName': string;
    /**
     * 担当者IDリスト
     * @type {Array<string>}
     * @memberof PostForecastForReceiptInfo
     */
    'forecastForReceiptResponsibleUserIdList'?: Array<string>;
    /**
     * 出力範囲
     * @type {number}
     * @memberof PostForecastForReceiptInfo
     */
    'outputRange': number;
}
/**
 * 
 * @export
 * @interface PostForecastForReceiptRequest
 */
export interface PostForecastForReceiptRequest {
    /**
     * 
     * @type {PostForecastForReceiptInfo}
     * @memberof PostForecastForReceiptRequest
     */
    'postForecastForReceiptInfo'?: PostForecastForReceiptInfo;
}
/**
 * 受領用内示登録レスポンスで返す情報
 * @export
 * @interface PostForecastForReceiptResponse
 */
export interface PostForecastForReceiptResponse {
    /**
     * 
     * @type {number}
     * @memberof PostForecastForReceiptResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof PostForecastForReceiptResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof PostForecastForReceiptResponse
     */
    'message': string;
    /**
     * 
     * @type {PostForecastForReceiptResponseResult}
     * @memberof PostForecastForReceiptResponse
     */
    'result': PostForecastForReceiptResponseResult;
}
/**
 * 受領用情報登録レスポンスで返す情報
 * @export
 * @interface PostForecastForReceiptResponseResult
 */
export interface PostForecastForReceiptResponseResult {
    /**
     * グループID
     * @type {string}
     * @memberof PostForecastForReceiptResponseResult
     */
    'forecastForReceiptId'?: string;
}
/**
 * 
 * @export
 * @interface PutForecastForReceiptRequest
 */
export interface PutForecastForReceiptRequest {
    /**
     * 
     * @type {UpdateForecastForReceiptInfo}
     * @memberof PutForecastForReceiptRequest
     */
    'updateForecastForReceiptInfo'?: UpdateForecastForReceiptInfo;
}
/**
 * 成功レスポンス
 * @export
 * @interface SuccessResponse
 */
export interface SuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof SuccessResponse
     */
    'result': object;
}
/**
 * 受領用内示を更新する情報
 * @export
 * @interface UpdateForecastForReceiptInfo
 */
export interface UpdateForecastForReceiptInfo {
    /**
     * 受領用内示名
     * @type {string}
     * @memberof UpdateForecastForReceiptInfo
     */
    'forecastForReceiptName'?: string;
    /**
     * 担当者IDリスト
     * @type {Array<string>}
     * @memberof UpdateForecastForReceiptInfo
     */
    'forecastForReceiptResponsibleUserIdList'?: Array<string>;
    /**
     * 出力範囲
     * @type {number}
     * @memberof UpdateForecastForReceiptInfo
     */
    'outputRange'?: number;
}
/**
 * 受領用内示更新レスポンスで返す情報
 * @export
 * @interface UpdateForecastForReceiptResponse
 */
export interface UpdateForecastForReceiptResponse {
    /**
     * 
     * @type {number}
     * @memberof UpdateForecastForReceiptResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateForecastForReceiptResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateForecastForReceiptResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof UpdateForecastForReceiptResponse
     */
    'result': object;
}
/**
 * ユーザーデータ
 * @export
 * @interface UserData
 */
export interface UserData {
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'name'?: string;
}

/**
 * ForecastForReceiptApi - axios parameter creator
 * @export
 */
export const ForecastForReceiptApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 受領用内示の担当者を一括更新する
         * @param {BulkUpdateForecastForReceiptRequest} bulkUpdateForecastForReceiptRequest 一括更新する受領用内示情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateForecastForReceipt: async (bulkUpdateForecastForReceiptRequest: BulkUpdateForecastForReceiptRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkUpdateForecastForReceiptRequest' is not null or undefined
            assertParamExists('bulkUpdateForecastForReceipt', 'bulkUpdateForecastForReceiptRequest', bulkUpdateForecastForReceiptRequest)
            const localVarPath = `/forecast-for-receipt/bulk-update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateForecastForReceiptRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 受領用内示と関連取引情報の紐付けを解除する (中間テーブルから削除する)
         * @param {DeleteBaseBusinessForecastForReceiptRequest} deleteBaseBusinessForecastForReceiptRequest 削除する受領用内示と関連取引の情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBaseBusinessForecastForReceipt: async (deleteBaseBusinessForecastForReceiptRequest: DeleteBaseBusinessForecastForReceiptRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteBaseBusinessForecastForReceiptRequest' is not null or undefined
            assertParamExists('deleteBaseBusinessForecastForReceipt', 'deleteBaseBusinessForecastForReceiptRequest', deleteBaseBusinessForecastForReceiptRequest)
            const localVarPath = `/forecast-for-receipt/base-business`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteBaseBusinessForecastForReceiptRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 受領用内示テーブルの情報を削除する
         * @param {DeleteForecastForReceiptRequest} deleteForecastForReceiptRequest 削除する受領用内示テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteForecastForReceipt: async (deleteForecastForReceiptRequest: DeleteForecastForReceiptRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteForecastForReceiptRequest' is not null or undefined
            assertParamExists('deleteForecastForReceipt', 'deleteForecastForReceiptRequest', deleteForecastForReceiptRequest)
            const localVarPath = `/forecast-for-receipt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteForecastForReceiptRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 受領用内示テーブルの情報を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastForReceipt: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/forecast-for-receipt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 担当者ごとの内示回収状況を取得する
         * @param {number} receivedYear 内示受領年
         * @param {number} receivedMonth 内示受領月
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastForReceiptStaffSummary: async (receivedYear: number, receivedMonth: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'receivedYear' is not null or undefined
            assertParamExists('getForecastForReceiptStaffSummary', 'receivedYear', receivedYear)
            // verify required parameter 'receivedMonth' is not null or undefined
            assertParamExists('getForecastForReceiptStaffSummary', 'receivedMonth', receivedMonth)
            const localVarPath = `/forecast-for-receipt/staff-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (receivedYear !== undefined) {
                localVarQueryParameter['receivedYear'] = receivedYear;
            }

            if (receivedMonth !== undefined) {
                localVarQueryParameter['receivedMonth'] = receivedMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 受領用内示ごとの回収状況を取得する（担当者でフィルタ可能）
         * @param {number} receivedYear 内示受領年
         * @param {number} receivedMonth 内示受領月
         * @param {string} [userIds] フィルタする担当者IDリスト（カンマ区切り）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastForReceiptSummary: async (receivedYear: number, receivedMonth: number, userIds?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'receivedYear' is not null or undefined
            assertParamExists('getForecastForReceiptSummary', 'receivedYear', receivedYear)
            // verify required parameter 'receivedMonth' is not null or undefined
            assertParamExists('getForecastForReceiptSummary', 'receivedMonth', receivedMonth)
            const localVarPath = `/forecast-for-receipt/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (receivedYear !== undefined) {
                localVarQueryParameter['receivedYear'] = receivedYear;
            }

            if (receivedMonth !== undefined) {
                localVarQueryParameter['receivedMonth'] = receivedMonth;
            }

            if (userIds !== undefined) {
                localVarQueryParameter['userIds'] = userIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 受領用内示テーブルの情報をエクセルに出力する
         * @param {string} requestUserId 出力対象担当者ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutputForecastForReceipt: async (requestUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestUserId' is not null or undefined
            assertParamExists('getOutputForecastForReceipt', 'requestUserId', requestUserId)
            const localVarPath = `/output-forecast-for-receipt/{requestUserId}`
                .replace(`{${"requestUserId"}}`, encodeURIComponent(String(requestUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 受領用内示と関連取引情報の紐付けを解除する (中間テーブルから削除する)
         * @param {PostBaseBusinessToForecastForReceiptRequest} postBaseBusinessToForecastForReceiptRequest 登録する受領用内示と関連取引の情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBaseBusinessToForecastForReceipt: async (postBaseBusinessToForecastForReceiptRequest: PostBaseBusinessToForecastForReceiptRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postBaseBusinessToForecastForReceiptRequest' is not null or undefined
            assertParamExists('postBaseBusinessToForecastForReceipt', 'postBaseBusinessToForecastForReceiptRequest', postBaseBusinessToForecastForReceiptRequest)
            const localVarPath = `/forecast-for-receipt/base-business`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postBaseBusinessToForecastForReceiptRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 受領用内示テーブルに情報を登録する
         * @param {PostForecastForReceiptRequest} postForecastForReceiptRequest 登録する受領用内示テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postForecastForReceipt: async (postForecastForReceiptRequest: PostForecastForReceiptRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postForecastForReceiptRequest' is not null or undefined
            assertParamExists('postForecastForReceipt', 'postForecastForReceiptRequest', postForecastForReceiptRequest)
            const localVarPath = `/forecast-for-receipt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postForecastForReceiptRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 受領用内示テーブルの情報を更新する
         * @param {string} forecastForReceiptId 受領用内示ID
         * @param {PutForecastForReceiptRequest} putForecastForReceiptRequest 更新する受領用内示テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putForecastForReceipt: async (forecastForReceiptId: string, putForecastForReceiptRequest: PutForecastForReceiptRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'forecastForReceiptId' is not null or undefined
            assertParamExists('putForecastForReceipt', 'forecastForReceiptId', forecastForReceiptId)
            // verify required parameter 'putForecastForReceiptRequest' is not null or undefined
            assertParamExists('putForecastForReceipt', 'putForecastForReceiptRequest', putForecastForReceiptRequest)
            const localVarPath = `/forecast-for-receipt/{forecastForReceiptId}`
                .replace(`{${"forecastForReceiptId"}}`, encodeURIComponent(String(forecastForReceiptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putForecastForReceiptRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ForecastForReceiptApi - functional programming interface
 * @export
 */
export const ForecastForReceiptApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ForecastForReceiptApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 受領用内示の担当者を一括更新する
         * @param {BulkUpdateForecastForReceiptRequest} bulkUpdateForecastForReceiptRequest 一括更新する受領用内示情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateForecastForReceipt(bulkUpdateForecastForReceiptRequest: BulkUpdateForecastForReceiptRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkUpdateForecastForReceiptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateForecastForReceipt(bulkUpdateForecastForReceiptRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ForecastForReceiptApi.bulkUpdateForecastForReceipt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 受領用内示と関連取引情報の紐付けを解除する (中間テーブルから削除する)
         * @param {DeleteBaseBusinessForecastForReceiptRequest} deleteBaseBusinessForecastForReceiptRequest 削除する受領用内示と関連取引の情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBaseBusinessForecastForReceipt(deleteBaseBusinessForecastForReceiptRequest: DeleteBaseBusinessForecastForReceiptRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteBaseBusinessToForecastForReceiptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBaseBusinessForecastForReceipt(deleteBaseBusinessForecastForReceiptRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ForecastForReceiptApi.deleteBaseBusinessForecastForReceipt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 受領用内示テーブルの情報を削除する
         * @param {DeleteForecastForReceiptRequest} deleteForecastForReceiptRequest 削除する受領用内示テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteForecastForReceipt(deleteForecastForReceiptRequest: DeleteForecastForReceiptRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteForecastForReceiptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteForecastForReceipt(deleteForecastForReceiptRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ForecastForReceiptApi.deleteForecastForReceipt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 受領用内示テーブルの情報を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForecastForReceipt(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetForecastForReceiptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getForecastForReceipt(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ForecastForReceiptApi.getForecastForReceipt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 担当者ごとの内示回収状況を取得する
         * @param {number} receivedYear 内示受領年
         * @param {number} receivedMonth 内示受領月
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForecastForReceiptStaffSummary(receivedYear: number, receivedMonth: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetForecastForReceiptStaffSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getForecastForReceiptStaffSummary(receivedYear, receivedMonth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ForecastForReceiptApi.getForecastForReceiptStaffSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 受領用内示ごとの回収状況を取得する（担当者でフィルタ可能）
         * @param {number} receivedYear 内示受領年
         * @param {number} receivedMonth 内示受領月
         * @param {string} [userIds] フィルタする担当者IDリスト（カンマ区切り）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForecastForReceiptSummary(receivedYear: number, receivedMonth: number, userIds?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetForecastForReceiptSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getForecastForReceiptSummary(receivedYear, receivedMonth, userIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ForecastForReceiptApi.getForecastForReceiptSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 受領用内示テーブルの情報をエクセルに出力する
         * @param {string} requestUserId 出力対象担当者ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOutputForecastForReceipt(requestUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOutputForecastForReceiptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOutputForecastForReceipt(requestUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ForecastForReceiptApi.getOutputForecastForReceipt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 受領用内示と関連取引情報の紐付けを解除する (中間テーブルから削除する)
         * @param {PostBaseBusinessToForecastForReceiptRequest} postBaseBusinessToForecastForReceiptRequest 登録する受領用内示と関連取引の情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postBaseBusinessToForecastForReceipt(postBaseBusinessToForecastForReceiptRequest: PostBaseBusinessToForecastForReceiptRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostBaseBusinessToForecastForReceiptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postBaseBusinessToForecastForReceipt(postBaseBusinessToForecastForReceiptRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ForecastForReceiptApi.postBaseBusinessToForecastForReceipt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 受領用内示テーブルに情報を登録する
         * @param {PostForecastForReceiptRequest} postForecastForReceiptRequest 登録する受領用内示テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postForecastForReceipt(postForecastForReceiptRequest: PostForecastForReceiptRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostForecastForReceiptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postForecastForReceipt(postForecastForReceiptRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ForecastForReceiptApi.postForecastForReceipt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 受領用内示テーブルの情報を更新する
         * @param {string} forecastForReceiptId 受領用内示ID
         * @param {PutForecastForReceiptRequest} putForecastForReceiptRequest 更新する受領用内示テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putForecastForReceipt(forecastForReceiptId: string, putForecastForReceiptRequest: PutForecastForReceiptRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateForecastForReceiptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putForecastForReceipt(forecastForReceiptId, putForecastForReceiptRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ForecastForReceiptApi.putForecastForReceipt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ForecastForReceiptApi - factory interface
 * @export
 */
export const ForecastForReceiptApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ForecastForReceiptApiFp(configuration)
    return {
        /**
         * 
         * @summary 受領用内示の担当者を一括更新する
         * @param {BulkUpdateForecastForReceiptRequest} bulkUpdateForecastForReceiptRequest 一括更新する受領用内示情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateForecastForReceipt(bulkUpdateForecastForReceiptRequest: BulkUpdateForecastForReceiptRequest, options?: any): AxiosPromise<BulkUpdateForecastForReceiptResponse> {
            return localVarFp.bulkUpdateForecastForReceipt(bulkUpdateForecastForReceiptRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 受領用内示と関連取引情報の紐付けを解除する (中間テーブルから削除する)
         * @param {DeleteBaseBusinessForecastForReceiptRequest} deleteBaseBusinessForecastForReceiptRequest 削除する受領用内示と関連取引の情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBaseBusinessForecastForReceipt(deleteBaseBusinessForecastForReceiptRequest: DeleteBaseBusinessForecastForReceiptRequest, options?: any): AxiosPromise<DeleteBaseBusinessToForecastForReceiptResponse> {
            return localVarFp.deleteBaseBusinessForecastForReceipt(deleteBaseBusinessForecastForReceiptRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 受領用内示テーブルの情報を削除する
         * @param {DeleteForecastForReceiptRequest} deleteForecastForReceiptRequest 削除する受領用内示テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteForecastForReceipt(deleteForecastForReceiptRequest: DeleteForecastForReceiptRequest, options?: any): AxiosPromise<DeleteForecastForReceiptResponse> {
            return localVarFp.deleteForecastForReceipt(deleteForecastForReceiptRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 受領用内示テーブルの情報を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastForReceipt(options?: any): AxiosPromise<GetForecastForReceiptResponse> {
            return localVarFp.getForecastForReceipt(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 担当者ごとの内示回収状況を取得する
         * @param {number} receivedYear 内示受領年
         * @param {number} receivedMonth 内示受領月
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastForReceiptStaffSummary(receivedYear: number, receivedMonth: number, options?: any): AxiosPromise<GetForecastForReceiptStaffSummaryResponse> {
            return localVarFp.getForecastForReceiptStaffSummary(receivedYear, receivedMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 受領用内示ごとの回収状況を取得する（担当者でフィルタ可能）
         * @param {number} receivedYear 内示受領年
         * @param {number} receivedMonth 内示受領月
         * @param {string} [userIds] フィルタする担当者IDリスト（カンマ区切り）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastForReceiptSummary(receivedYear: number, receivedMonth: number, userIds?: string, options?: any): AxiosPromise<GetForecastForReceiptSummaryResponse> {
            return localVarFp.getForecastForReceiptSummary(receivedYear, receivedMonth, userIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 受領用内示テーブルの情報をエクセルに出力する
         * @param {string} requestUserId 出力対象担当者ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutputForecastForReceipt(requestUserId: string, options?: any): AxiosPromise<GetOutputForecastForReceiptResponse> {
            return localVarFp.getOutputForecastForReceipt(requestUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 受領用内示と関連取引情報の紐付けを解除する (中間テーブルから削除する)
         * @param {PostBaseBusinessToForecastForReceiptRequest} postBaseBusinessToForecastForReceiptRequest 登録する受領用内示と関連取引の情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBaseBusinessToForecastForReceipt(postBaseBusinessToForecastForReceiptRequest: PostBaseBusinessToForecastForReceiptRequest, options?: any): AxiosPromise<PostBaseBusinessToForecastForReceiptResponse> {
            return localVarFp.postBaseBusinessToForecastForReceipt(postBaseBusinessToForecastForReceiptRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 受領用内示テーブルに情報を登録する
         * @param {PostForecastForReceiptRequest} postForecastForReceiptRequest 登録する受領用内示テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postForecastForReceipt(postForecastForReceiptRequest: PostForecastForReceiptRequest, options?: any): AxiosPromise<PostForecastForReceiptResponse> {
            return localVarFp.postForecastForReceipt(postForecastForReceiptRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 受領用内示テーブルの情報を更新する
         * @param {string} forecastForReceiptId 受領用内示ID
         * @param {PutForecastForReceiptRequest} putForecastForReceiptRequest 更新する受領用内示テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putForecastForReceipt(forecastForReceiptId: string, putForecastForReceiptRequest: PutForecastForReceiptRequest, options?: any): AxiosPromise<UpdateForecastForReceiptResponse> {
            return localVarFp.putForecastForReceipt(forecastForReceiptId, putForecastForReceiptRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ForecastForReceiptApi - object-oriented interface
 * @export
 * @class ForecastForReceiptApi
 * @extends {BaseAPI}
 */
export class ForecastForReceiptApi extends BaseAPI {
    /**
     * 
     * @summary 受領用内示の担当者を一括更新する
     * @param {BulkUpdateForecastForReceiptRequest} bulkUpdateForecastForReceiptRequest 一括更新する受領用内示情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForecastForReceiptApi
     */
    public bulkUpdateForecastForReceipt(bulkUpdateForecastForReceiptRequest: BulkUpdateForecastForReceiptRequest, options?: RawAxiosRequestConfig) {
        return ForecastForReceiptApiFp(this.configuration).bulkUpdateForecastForReceipt(bulkUpdateForecastForReceiptRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 受領用内示と関連取引情報の紐付けを解除する (中間テーブルから削除する)
     * @param {DeleteBaseBusinessForecastForReceiptRequest} deleteBaseBusinessForecastForReceiptRequest 削除する受領用内示と関連取引の情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForecastForReceiptApi
     */
    public deleteBaseBusinessForecastForReceipt(deleteBaseBusinessForecastForReceiptRequest: DeleteBaseBusinessForecastForReceiptRequest, options?: RawAxiosRequestConfig) {
        return ForecastForReceiptApiFp(this.configuration).deleteBaseBusinessForecastForReceipt(deleteBaseBusinessForecastForReceiptRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 受領用内示テーブルの情報を削除する
     * @param {DeleteForecastForReceiptRequest} deleteForecastForReceiptRequest 削除する受領用内示テーブル情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForecastForReceiptApi
     */
    public deleteForecastForReceipt(deleteForecastForReceiptRequest: DeleteForecastForReceiptRequest, options?: RawAxiosRequestConfig) {
        return ForecastForReceiptApiFp(this.configuration).deleteForecastForReceipt(deleteForecastForReceiptRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 受領用内示テーブルの情報を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForecastForReceiptApi
     */
    public getForecastForReceipt(options?: RawAxiosRequestConfig) {
        return ForecastForReceiptApiFp(this.configuration).getForecastForReceipt(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 担当者ごとの内示回収状況を取得する
     * @param {number} receivedYear 内示受領年
     * @param {number} receivedMonth 内示受領月
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForecastForReceiptApi
     */
    public getForecastForReceiptStaffSummary(receivedYear: number, receivedMonth: number, options?: RawAxiosRequestConfig) {
        return ForecastForReceiptApiFp(this.configuration).getForecastForReceiptStaffSummary(receivedYear, receivedMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 受領用内示ごとの回収状況を取得する（担当者でフィルタ可能）
     * @param {number} receivedYear 内示受領年
     * @param {number} receivedMonth 内示受領月
     * @param {string} [userIds] フィルタする担当者IDリスト（カンマ区切り）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForecastForReceiptApi
     */
    public getForecastForReceiptSummary(receivedYear: number, receivedMonth: number, userIds?: string, options?: RawAxiosRequestConfig) {
        return ForecastForReceiptApiFp(this.configuration).getForecastForReceiptSummary(receivedYear, receivedMonth, userIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 受領用内示テーブルの情報をエクセルに出力する
     * @param {string} requestUserId 出力対象担当者ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForecastForReceiptApi
     */
    public getOutputForecastForReceipt(requestUserId: string, options?: RawAxiosRequestConfig) {
        return ForecastForReceiptApiFp(this.configuration).getOutputForecastForReceipt(requestUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 受領用内示と関連取引情報の紐付けを解除する (中間テーブルから削除する)
     * @param {PostBaseBusinessToForecastForReceiptRequest} postBaseBusinessToForecastForReceiptRequest 登録する受領用内示と関連取引の情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForecastForReceiptApi
     */
    public postBaseBusinessToForecastForReceipt(postBaseBusinessToForecastForReceiptRequest: PostBaseBusinessToForecastForReceiptRequest, options?: RawAxiosRequestConfig) {
        return ForecastForReceiptApiFp(this.configuration).postBaseBusinessToForecastForReceipt(postBaseBusinessToForecastForReceiptRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 受領用内示テーブルに情報を登録する
     * @param {PostForecastForReceiptRequest} postForecastForReceiptRequest 登録する受領用内示テーブル情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForecastForReceiptApi
     */
    public postForecastForReceipt(postForecastForReceiptRequest: PostForecastForReceiptRequest, options?: RawAxiosRequestConfig) {
        return ForecastForReceiptApiFp(this.configuration).postForecastForReceipt(postForecastForReceiptRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 受領用内示テーブルの情報を更新する
     * @param {string} forecastForReceiptId 受領用内示ID
     * @param {PutForecastForReceiptRequest} putForecastForReceiptRequest 更新する受領用内示テーブル情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForecastForReceiptApi
     */
    public putForecastForReceipt(forecastForReceiptId: string, putForecastForReceiptRequest: PutForecastForReceiptRequest, options?: RawAxiosRequestConfig) {
        return ForecastForReceiptApiFp(this.configuration).putForecastForReceipt(forecastForReceiptId, putForecastForReceiptRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



